import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PayloadContext } from '../context';
import { querystring } from '../utils';

const UnauthRoute = ({ children, ...rest }) =>
{
	const { payload } = useContext(PayloadContext);

	const redirect = querystring('redirect');

	const excludepaths = [ '/guest-join/:id', '/guest-session/:sessionId' ];

	return (
		<Route {...rest} render={({ location }) =>
		{
			return (payload === null || excludepaths.indexOf(rest.path) >= 0)
				? children
				: <Redirect to={{
					pathname : redirect === '' || redirect === null ? '/dashboard' : redirect,

					state : { from: location }
				}}/>;
		}
		}
		/>
	);
	// return (
	// 	<Route {...rest} render={(props) =>
	// 	{
	// 		return payload === null
	// 			? <Route exact path={props.path} component={props.component} />
	// 			: <Redirect to={redirect === '' || redirect === null ? '/dashboard' : redirect} />;
	// 	}
	// 	}
	// 	/>
	// );
};

export default UnauthRoute;